import { render } from "./ReadonlyField.vue?vue&type=template&id=163c295c&scoped=true&ts=true"
import script from "./ReadonlyField.vue?vue&type=script&lang=ts"
export * from "./ReadonlyField.vue?vue&type=script&lang=ts"

import "./ReadonlyField.vue?vue&type=style&index=0&id=163c295c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163c295c"]])

export default __exports__